<template>
    <div
        class="prod-rating-snapshot d-flex flex-column font-size-8"
    >
        <table>
            <tbody>
                <tr
                    v-for="(count, i) in c"
                >
                    <td>
                        {{ num[i]! + 1 }} star<template v-if="i < 4">s</template>
                    </td>
                    <td>
                        <v-progress-linear
                            :model-value="(count * 100) / total"
                            color="secondary"
                            height="14"
                            rounded
                        ></v-progress-linear>
                    </td>
                    <td>
                        {{ count }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps<{
        counts: number[];
        total: number;
    }>();

    const num = ref([...Array(5).keys()].reverse());
    const c = ref([...props.counts].reverse());
</script>

<style lang="scss">
.prod-rating-snapshot {
    & > table {
        td:nth-child(1) {
            width: 1px;
            padding-right: 0.6rem;
            white-space: nowrap;
        }

        td:nth-child(2) {
            width: auto;
        }

        td:nth-child(3) {
            width: 1px;
            padding-left: 0.4rem;
        }
    }
}
</style>
